import { app } from '../../../../app';
import { Controller } from './account-config.controller';

app.component('accountConfig', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./account-config.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/account-config/account-config.component.js